<div class="row h-100">
  <div class="col d-flex justify-content-center align-items-center">
    <div class="brand-card">
      <span class="accent-bar"></span>
      <div class="inner-container text-center">
        <div class="error-icon-badge">
          <mat-icon aria-hidden="true">error_outline</mat-icon>
        </div>

        <p class="welcome-eyebrow">Something went wrong</p>
        <h2 class="error-title">{{ error.friendlyName }}</h2>

        @if (error.actionText) {
          <button type="button" class="error-action tbp" (click)="triggerErrorAction()">
            {{ error.actionText }}
          </button>
        }

        @if (id) {
          <div class="reference">
            <p class="reference-hint">Please give this reference code to Highfield support so we can investigate.</p>
            <div class="code-row">
              <code class="code">{{ id }}</code>
              <button type="button" class="copy-btn"
                      [matTooltip]="tooltipText()" matTooltipPosition="above"
                      (click)="copy($event)" (mouseout)="setTooltipTextDefault()">
                <mat-icon aria-hidden="true">content_copy</mat-icon>
                <span>Copy</span>
              </button>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
